// extracted by mini-css-extract-plugin
export var option = "_4y-0";
export var optionCard = "_4y-f";
export var optionContent = "_4y-g";
export var optionIcon = "_4y-i";
export var optionIconBox = "_4y-h";
export var optionLabel = "_4y-j";
export var optionPill = "_4y-m";
export var optionPillBadge = "_4y-p";
export var optionPillIcon = "_4y-n";
export var optionPillLabel = "_4y-o";
export var optionRadio = "_4y-k";
export var optionRadioInner = "_4y-l";
export var optionReveal = "_4y-2";
export var optionRevealDelay0 = "_4y-3";
export var optionRevealDelay1 = "_4y-4";
export var optionRevealDelay10 = "_4y-d";
export var optionRevealDelay11 = "_4y-e";
export var optionRevealDelay2 = "_4y-5";
export var optionRevealDelay3 = "_4y-6";
export var optionRevealDelay4 = "_4y-7";
export var optionRevealDelay5 = "_4y-8";
export var optionRevealDelay6 = "_4y-9";
export var optionRevealDelay7 = "_4y-a";
export var optionRevealDelay8 = "_4y-b";
export var optionRevealDelay9 = "_4y-c";
export var optionSelected = "_4y-1";